import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import {
    loadCountryNameDropdown,
    loadStateNameDropdown,
    loadCityNameDropdown,
    postAddressDataData,
} from '../redux/action';
import { ClearBtn, SearchBtn } from '../Buttons/Buttons';
import * as HeaderAuthentication from '../../components/HeaderAuthentication'

const ProfileAddressEditModal = ({ show, handleClose, fetchProfileData, signInID }) => {
    const dispatch = useDispatch();
    const { countryNameDropdown, stateDropdownData, cityDropdownData } = useSelector((state) => state.data);

    const [formData, setFormData] = useState({
        address1: '',
        address2: '',
        country: null,
        state: null,
        city: null,
        postalCode: '',
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        dispatch(loadCountryNameDropdown());
    }, [dispatch]);

    useEffect(() => {
        if (formData.country?.value) {
            dispatch(loadStateNameDropdown(formData.country.value, null));
        }
    }, [formData.country, dispatch]);

    useEffect(() => {
        if (formData.state?.value) {
            dispatch(loadCityNameDropdown(formData.state.value, null));
        }
    }, [formData.state, dispatch]);

    const handleChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
            ...(field === 'country' && { state: null, city: null }),
            ...(field === 'state' && { city: null }),
        }));

        // Clear error for this field when the user starts typing/selecting
        setErrors((prev) => ({ ...prev, [field]: '' }));
    };

    const handleSubmit = () => {
        const newErrors = {};
        if (!formData.address1) newErrors.address1 = 'Address 1 is required';
        if (!formData.country) newErrors.country = 'Country is required';
        if (!formData.postalCode) newErrors.postalCode = 'Postal Code is required';

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) return;

        const requestPayload = {
            address_line_1: formData.address1,
            address_line_2: formData.address2,
            country: formData.country?.label || '',
            admin_area_1: formData.state?.label || '',
            admin_area_2: formData.city?.label || '',
            postal_code: formData.postalCode,
            user_id: signInID,
        };

        const requestOption = {
            method: 'POST',
            mode: 'cors',
            headers: HeaderAuthentication.postAuthOfLeadMerge,
            body: JSON.stringify(requestPayload),
        };

        dispatch(postAddressDataData(requestOption, fetchProfileData, handleClose));
    };

    return (
        <Modal show={show} onHide={handleClose} centered className="contact-level-modal">
            <Modal.Header closeButton>
                <Modal.Title>Edit Address</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ overflow: 'auto' }}>
                <Form>
                    <Form.Group className="mb-2">
                        <Form.Label>Address 1</Form.Label>
                        <Form.Control
                            type="text"
                            value={formData.address1}
                            onChange={(e) => handleChange('address1', e.target.value)}
                        />
                        {errors.address1 && <div className="text-danger">{errors.address1}</div>}
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Label>Address 2</Form.Label>
                        <Form.Control
                            type="text"
                            value={formData.address2}
                            onChange={(e) => handleChange('address2', e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Label>Country</Form.Label>
                        <Select
                            options={countryNameDropdown}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: base => ({ ...base, zIndex: 9999 })
                            }}
                            value={formData.country}
                            onChange={(option) => handleChange('country', option)}
                        />
                        {errors.country && <div className="text-danger">{errors.country}</div>}
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Label>State</Form.Label>
                        <Select
                            options={stateDropdownData}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: base => ({ ...base, zIndex: 9999 })
                            }}
                            value={formData.state}
                            onChange={(option) => handleChange('state', option)}
                            isDisabled={!formData.country}
                        />
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Label>City</Form.Label>
                        <Select
                            options={cityDropdownData}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: base => ({ ...base, zIndex: 9999 })
                            }}
                            value={formData.city}
                            onChange={(option) => handleChange('city', option)}
                            isDisabled={!formData.state}
                        />
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Label>Postal Code</Form.Label>
                        <Form.Control
                            type="text"
                            value={formData.postalCode}
                            onChange={(e) => handleChange('postalCode', e.target.value)}
                        />
                        {errors.postalCode && <div className="text-danger">{errors.postalCode}</div>}
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <ClearBtn btnName="Cancel" onClickEffect={handleClose} />
                <SearchBtn btnName="Submit" onClickEffect={handleSubmit} />
            </Modal.Footer>
        </Modal>
    );
};

export default ProfileAddressEditModal;
